import React, { PureComponent } from 'react';

class RadioButton extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let NuevaSolicitudEmpresaRadio;
        let empresaSeleccionada = this.props.tarjetas.tipoEmpresa.Id ? this.props.tarjetas.tipoEmpresa.Id : 0;
        let me = this;

        NuevaSolicitudEmpresaRadio = this.props.empresas.map(function (rowEmp) {
            let checked = (empresaSeleccionada == rowEmp.Id) ? true : false;
            let classSelected = checked ? "selected" : "";
            let disabledProp = { disabled: "disabled" };
                    
            return (
                <div className={"row"} >
                    <div className={"col-md-12 bottom-separator separator-light " + classSelected} key={rowEmp.Id}>
                        <div className="container-radio radio-margin bottom-separatorTipoEmp">
                            <input type="radio" name="rb" id={rowEmp.Id} checked={checked}
                                onClick={() => {me.handleClick(rowEmp) }}
                                /*{...disabledProp}*/ ></input>
                            <label className="lbl-radio label-secondary" htmlFor={rowEmp.Id}><span className="tipoEmpNew">{rowEmp.Descripcion}</span></label>
                        </div>
                    </div>
                </div>
            );
        })
            

        return (

            <div className="container-fluid bottom-separator-marca" >
                {NuevaSolicitudEmpresaRadio}
            </div>

        )
    }

    handleClick(data) {
        this.props.selectRadioButton(data)
    }

}


export default RadioButton;